import { useEffect, useState } from "react";
import { ListNotificationsUseCase } from "../../Usecase/Notifications/list-notifications-usecase";
import { INotificationEntity } from "../../Services/api/notifications/notifications.interface";
import { useToast } from "../../Hooks/ToasContext";
import { useAuth } from "../../Hooks/Auth";


interface IUseNotificationMenuProps {
    listNotificationsUseCase: ListNotificationsUseCase
    
  }

export function useNotifications({ listNotificationsUseCase }: IUseNotificationMenuProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<INotificationEntity[]>([])
    const [totalUnreadNotifications, setTotalUnreadNotifications] = useState(0)
    const [totalRegisters, setTotalRegisters] = useState(1)
    const { showToast } =  useToast()
    const { user } = useAuth()
   
    const handleClick = (event: any) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
  
  
  
    const loadNotifications = async ({ page: currentPage, searchBy }: any) => {
          
      try {
       
        
        const listResult = await listNotificationsUseCase.handle({ page: 1 });
  
        if (listResult.isFailure) {
          showToast(String(listResult?.error?.error ?? 'Erro ao carregar notificações'), 'error');
          return;
        }
  
       const list = listResult.getValue()

      setTotalUnreadNotifications(list?.data?.length || 0)
  
     
       setData(list?.data || [])
       setTotalRegisters(list?.total || 0)
       
  
  
       setPage(currentPage)
      } catch (error) {
        console.log("error listCustomers function: ", error)
      } finally {
        setLoading(false);
      }
  };
  
    useEffect(() => {
     
      loadNotifications({ page: 1 })
  
    }, [])

    return {
        listNotificationsUseCase,
        anchorEl,
        open,
        handleClick,
        handleClose,
        loading,
        data,
        totalRegisters,
        page,
        loadNotifications,
        totalUnreadNotifications
    }
}